module.exports = "/static-assets/_next/static/images/salem-7add944165a11a7b0a84f167b0e9e5d7.png";